import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtPrice = (n) =>
  n > 0 ? `$${Number(n).toLocaleString("en-US")}` : "Inquire";

// Serve smaller, format-optimized images. For Unsplash URLs we cap width/quality
// (huge full-res photos were the cause of slow loads); other URLs are returned as-is.
export function optimizeImg(url, w = 800) {
  if (!url || typeof url !== "string") return url;
  if (!/images\.unsplash\.com/.test(url)) return url;
  const [base] = url.split("?");
  return `${base}?auto=format&fit=crop&w=${w}&q=70`;
}

export function applyTheme(s) {
  if (!s) return;
  const r = document.documentElement.style;
  if (s.display_font) r.setProperty("--font-display", `'${s.display_font}'`);
  if (s.body_font) r.setProperty("--font-body", `'${s.body_font}'`);
  if (s.scale) r.setProperty("--text-scale", String(s.scale));
}


// Convert a pasted social URL (Instagram reel/post, YouTube watch/shorts) into an embeddable iframe src.
export function toEmbed(raw) {
  const url = (raw || "").trim();
  if (!url) return "";
  const ig = url.match(/instagram\.com\/(reel|reels|p|tv)\/([A-Za-z0-9_-]+)/i);
  if (ig) {
    const kind = ig[1] === "reels" ? "reel" : ig[1];
    return `https://www.instagram.com/${kind}/${ig[2]}/embed`;
  }
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{6,})/i);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  return url;
}